import { LESSON_MODULE_TYPES } from 'constants/index'

/* eslint-disable camelcase */
export { default } from './Icon'
export CircledIcon from './CircledIcon'
export IconSvgs, { OutlinedSvgs, SolidSvgs, Csk2Svgs } from './Icon/IconSvgs'

export const LessonTypeIcons = {
  applied: 'Writing',
  minilesson: 'DirectInstruction',
  quick_cerca: 'Reading',
  insta_cerca: '',
  vocabulary_assessment: '',
  practice_assessment: '',
  progress_monitor: 'CSK',
  skill_lesson: 'CSK',
  [LESSON_MODULE_TYPES.SKILL_EXERCISE]: 'CSK',
  [LESSON_MODULE_TYPES.WRITING_MODULES]: 'WritingModule',
  [LESSON_MODULE_TYPES.DIRECT_INSTRUCTION]: 'DirectInstruction',
  [LESSON_MODULE_TYPES.PRACTICE]: 'Reading',
  [LESSON_MODULE_TYPES.ASSESSMENT]: 'Reports',
  [LESSON_MODULE_TYPES.CORE_ELA]: 'Reports',
  'Skills & Concepts Instruction': 'CSK',
  'Applied Reading & Writing': 'Writing',
  'Additional Reading Practice': 'Reading',
  'Reading Practice': 'Reading',
  'Writing Lesson': 'Writing',
  'Writing Exercise': 'Writing',
  'Skills Lesson': 'CSK',
}
